module.exports = __webpack_public_path__ + "png/my-message-angle.png?d46426c2d602ed0b368ff20e9f7411f2";